import { CSSProperties, ReactNode } from 'react';
import { Stack, SxProps, Typography } from '@mui/material';
import EmptyIcon from '@/public/icons/empty.svg';
import CautionIcon from '@/public/icons/caution.svg';

type EmptyType = 'error' | 'empty';

type EmptyContentProps = {
  title: ReactNode;
  type?: EmptyType;
  height?: string;
  isFullScreen?: boolean;
  iconSize?: string;
  sx?: SxProps;
};

const EmptyContent = (props: EmptyContentProps) => {
  const {
    title,
    type = 'empty',
    height,
    isFullScreen,
    iconSize = '40px',
    sx,
  } = props;
  const defaultStyle: CSSProperties = {};

  if (isFullScreen) {
    defaultStyle.height = height ?? 'calc(100vh - 220px)';
    defaultStyle.minHeight = '220px';
  } else if (height) {
    defaultStyle.height = height;
  }

  return (
    <Stack
      direction={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      style={defaultStyle}
      spacing={0.5}
      sx={sx}
    >
      {type === 'empty' && <EmptyIcon width={iconSize} height={iconSize} />}
      {type === 'error' && <CautionIcon width={iconSize} height={iconSize} />}
      <Typography
        fontSize={14}
        style={{ color: 'var(--dk-text-dim, #B7BBC2)', textAlign: 'center' }}
        component="div"
      >
        {title}
      </Typography>
    </Stack>
  );
};

export default EmptyContent;
